<button
  [matMenuTriggerData]="userMenuData"
  [matMenuTriggerFor]="menu"
  (click)="toggleDropdown()"
>
  <ng-container *ngIf="problem">{{ problem?.problem }} </ng-container>
  <ng-container *ngIf="!problem">选择问题</ng-container>
  <img alt="arrow" width="20" height="20" [src]="src" />
</button>
<mat-menu #menu="matMenu" class="my-menu">
  <ng-template matMenuContent let-menuWidth="menuWidth">
    <div [style.width.px]="menuWidth">
      <button mat-menu-item *ngIf="problems?.length === 0">没有数据</button>
      <ng-container *ngFor="let data of problems">
        <button
          mat-menu-item
          *ngIf="data.status === 'InUse'"
          (click)="selectOption(data)"
        >
          <span>{{ data.problem }}</span>
        </button>
      </ng-container>
    </div>
  </ng-template>
</mat-menu>
